module.exports = __webpack_public_path__ + "img/1440.c2d331ff.jpg";